import { create } from 'zustand';
import { authApi, tokenStorage } from '../api/client';

export const useAuthStore = create((set) => ({
  user: tokenStorage.getUser(),
  isAuthenticated: !!tokenStorage.getAccess(),
  loading: false,
  error: null,

  login: async (email, password) => {
    set({ loading: true, error: null });
    try {
      const data = await authApi.login(email, password);
      set({ user: data.user, isAuthenticated: true, loading: false });
      return true;
    } catch (err) {
      set({ error: err.message, loading: false });
      return false;
    }
  },

  register: async (username, email, password) => {
    set({ loading: true, error: null });
    try {
      const data = await authApi.register(username, email, password);
      set({ user: data.user, isAuthenticated: true, loading: false });
      return true;
    } catch (err) {
      set({ error: err.message, loading: false });
      return false;
    }
  },

  logout: () => {
    authApi.logout();
    set({ user: null, isAuthenticated: false, error: null });
  },

  clearError: () => set({ error: null }),

  // Called when refresh token fails (sb-auth-expired event)
  sessionExpired: () => {
    set({ user: null, isAuthenticated: false });
  },
}));

export const isAdmin = (user) =>
  user?.role === 'admin' || user?.role === 'superadmin';
